// Hides notice banners the user has dismissed, persisting the choice in
// localStorage so the banner stays gone across reloads. Pinned notices still
// render once per publish — if the admin edits a notice we'd want it to
// reappear, so dismissals are keyed by notice id + updated_at hash, but the
// simplest version just keys on id.
const STORAGE_KEY = "dismissed-notices"

const loadDismissed = (): Set<string> => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return new Set()
    const parsed = JSON.parse(raw)
    return new Set(Array.isArray(parsed) ? parsed : [])
  } catch {
    return new Set()
  }
}

const saveDismissed = (ids: Set<string>) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]))
  } catch {
    /* storage disabled or full — accept the loss */
  }
}

export const DismissableNotices = {
  mounted(this: { el: HTMLElement }) {
    this._apply()
    this._attach()
  },

  updated(this: { el: HTMLElement; _apply: () => void; _attach: () => void }) {
    this._apply()
    this._attach()
  },

  _apply(this: { el: HTMLElement }) {
    const dismissed = loadDismissed()
    const banners = this.el.querySelectorAll<HTMLElement>("[data-notice-id]")
    let remaining = 0

    banners.forEach(banner => {
      const id = banner.dataset.noticeId
      if (!id) return
      if (dismissed.has(id)) {
        banner.style.display = "none"
      } else {
        banner.style.display = ""
        remaining++
      }
    })

    this.el.style.display = remaining === 0 ? "none" : ""
  },

  _attach(this: { el: HTMLElement; _apply: () => void }) {
    const buttons = this.el.querySelectorAll<HTMLElement>("[data-dismiss='true']")

    buttons.forEach(btn => {
      if (btn.dataset.dismissWired === "1") return
      btn.dataset.dismissWired = "1"
      btn.addEventListener("click", () => {
        const banner = btn.closest<HTMLElement>("[data-notice-id]")
        if (!banner) return
        const id = banner.dataset.noticeId
        if (!id) return

        const dismissed = loadDismissed()
        dismissed.add(id)
        saveDismissed(dismissed)
        this._apply()
      })
    })
  },
}
